import * as angular from 'angular';

class PanelSectionDetailsController {
  private isOpen: boolean;

  public getIsOpen() {
    return !!this.isOpen;
  }

  public displayWell() {
    return this.getIsOpen();
  }

  public displayCollapseButton(): boolean {
    return this.getIsOpen();
  }

  public displayOpenButton(): boolean {
    return !this.getIsOpen();
  }

  public toggle(): void {
    this.isOpen = !this.isOpen;
  }
}

export const PanelSectionDetailsComponent: angular.IComponentOptions = {
  controller: PanelSectionDetailsController,
  controllerAs: 'ctrl',
  transclude: true,
  bindings: {
    isOpen: '<',
  },
  template: `
    <div class="details-container">
      <div class="details-summary">
        <button
          class="details-toggle details-toggle-collapse"
          ng-show="ctrl.displayCollapseButton()"
          ng-click="ctrl.toggle()"
        >
          Hide Configuration <span class="icon-caret-down inverted"></span>
        </button>

        <button
          class="details-toggle details-toggle-open"
          ng-show="ctrl.displayOpenButton()"
          ng-click="ctrl.toggle()"
        >
          View Configuration <span class="icon-caret-down"></span>
        </button>
      </div>
      <div class="details-content">
        <div class="details-well" ng-show="ctrl.displayWell()">
          <ng-transclude />
        </div>
      </div>
    </div>
  `,
};
